import { ITableColumn } from '@components/common/UTable/UTable';

export const columns = [
  {
    title: '№ п/п',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: 'Дата и время обновления',
    dataIndex: 'createdAt',
    type: 'datetime',
    width: 150,
  },
  {
    title: 'Автор обновления',
    dataIndex: 'createdBy',
    width: 200,
  },
  {
    title: 'Действия',
    dataIndex: 'operation',
    width: 200,
  },
  {
    title: 'Наименование препарата',
    dataIndex: 'drugName',
    width: 200,
  },
  {
    title: 'Номер партии',
    dataIndex: 'batchNumber',
    width: 150,
  },
  {
    title: 'Дата конца срока годности',
    dataIndex: 'expirationDate',
    type: 'date',
    width: 150,
  },
  {
    title: 'Единица тары',
    dataIndex: 'packageUnit',
    payload: { defaultValue: '-' },
    width: 150,
  },
  {
    title: 'Кол-во до изменения\n(ед. тары)',
    dataIndex: 'packagesAmountBefore',
    width: 125,
    payload: { defaultValue: '-' },
  },
  {
    title: 'Кол-во изменения\n(ед. тары)',
    dataIndex: 'packagesAmountOfChange',
    width: 125,
  },
  {
    title: 'Кол-во после изменения\n(ед. тары)',
    dataIndex: 'packagesAmountAfter',
    width: 125,
  },
  {
    title: 'Единица содержимого',
    dataIndex: 'dosageUnit',
    payload: { defaultValue: '-' },
    width: 125,
  },
  {
    title: 'Объем/доза препарата\nна единицу тары',
    dataIndex: 'packageVolume',
    width: 150,
  },
  {
    title: 'Основание',
    dataIndex: 'basis',
    width: 200,
    payload: { defaultValue: '-' },
  },
] as ITableColumn[];
